export default __webpack_public_path__ + "static/media/482.66f5e30c.png";